import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import type { OverlapPeriods } from 'modules/work_schedules/store/collections/overlapPeriods'

export interface ISchedule {
  id: number
  name: string
  company_id: number
  archived_at: string
  created_at: string
  updated_at: string
  periods: OverlapPeriods
  employees: number[]
}

class Schedule extends Model<ISchedule> {
  constructor(attr: ISchedule) {
    super(attr)
    makeObservable(this, {
      employeeIds: computed,
      archived: computed,
    })
  }

  static urlRoot() {
    return '/work_schedule/schedules'
  }

  get employeeIds(): number[] {
    return this.attributes.employees
  }

  get archived(): boolean {
    return this.attributes.archived_at !== null
  }

  async archive(): Promise<void> {
    await this.rpc('toggle_archive')
    await this.fetch()
  }
}

export default Schedule
